import React, { useState, useEffect } from 'react';
import { supabase } from '../utils/supabaseClient';

const Beforehand1 = ({ setStep, setFormData, hospitalId }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    sessionStorage.setItem('lastPage', 'Beforehand1');
    
    // 初期値を設定
    setFormData(prev => ({
      ...prev,
      osteoporosisTreatment: null,
      boneDensityTest: null
    }));
    
    // セッションのリセットチェック - 前のセッションが完了しているか、ページ更新かをチェック
    const isCompletedSession = sessionStorage.getItem('session_completed') === 'true';
    const isPageRefresh = performance.navigation && performance.navigation.type === 1;
    
    if (isCompletedSession || isPageRefresh) {
      console.log('Beforehand1: 前のセッションは完了しているか、ページが更新されました。セッションIDをクリアします。');
      sessionStorage.removeItem('session_id');
      sessionStorage.removeItem('session_completed');
    }
  }, [setFormData]);

  const handleAnswer = async (answer) => {
    if (isSubmitting) return;
    
    setIsSubmitting(true);
    setFormData(prev => ({ ...prev, osteoporosisTreatment: answer === 'yes' }));

    try {
      // 既存のセッションIDを確認
      const existingSessionId = sessionStorage.getItem('session_id');
      if (existingSessionId) {
        console.log('既存のセッションIDを使用:', existingSessionId);
      } else {
        // 一時的なIDを生成（エラー時に使用）
        const tempSessionId = `temp-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
        
        // セッションを開始し、IDを取得
        try {
          const { data, error } = await supabase
            .from('sessions')
            .insert([{ 
              hospital_id: hospitalId
            }])
            .select('id');

          if (error) {
            console.error('Supabase session insert error:', error);
            // エラー時は一時的なIDを使用
            sessionStorage.setItem('session_id', tempSessionId);
            console.log('エラーのため一時的なセッションIDを使用:', tempSessionId);
          } else {
            const sessionId = data[0].id;
            sessionStorage.setItem('session_id', sessionId);
            console.log('セッション開始:', sessionId);
          }
        } catch (error) {
          console.error('セッション開始エラー:', error);
          // 例外発生時も一時的なIDを使用
          sessionStorage.setItem('session_id', tempSessionId);
          console.log('エラーのため一時的なセッションIDを使用:', tempSessionId);
        }
      }

      // セッション開始の成功/失敗に関わらず次の画面に進む
      if (answer === 'yes') {
        setStep(14); // ThankYou画面へ
      } else {
        setStep(1); // Beforehand2へ
      }
    } catch (error) {
      console.error('予期しないエラー:', error);
      // 重大なエラーでも次の画面に進む（UXを優先）
      if (answer === 'yes') {
        setStep(14);
      } else {
        setStep(1);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="p-4 bg-blue-100 rounded-lg">
      <h2 className="common-title mb-4">はじめに 1</h2>
      <p className="text-base mb-4 text-lg text-red-500">このチェックを始める前に、以下の質問にお答えください。</p>
      <p className="text-base mb-4 text-lg">1. あなたは現在、骨粗しょう症の治療中ですか？</p>
      <br />
      <div className="flex justify-between">
        <button 
          onClick={() => handleAnswer('yes')}
          className="bg-blue-500 text-white p-2 rounded hover:bg-blue-600 w-auto"
          disabled={isSubmitting}
        >
          はい
        </button>
        <button 
          onClick={() => handleAnswer('no')}
          className="bg-pink-500 text-white p-2 rounded hover:bg-pink-600 w-auto"
          disabled={isSubmitting}
        >
          いいえ
        </button>
      </div>
    </div>
  );
};

export default Beforehand1; 